module.exports = __webpack_public_path__ + "mg.ab73662e.svg";